"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleUtilities_1 = require("../../util/styleUtilities");
var colors = {
    colors: {
        primary: '#1b67d0',
        primaryDark: '#0653B6',
        primaryLight: '#d1e1f6',
        secondary: '#ff7600',
        secondaryLight: '#FFE9D6',
        secondaryDark: '#E56E00',
        tertiary: '#288271',
        tertiaryLight: '#E9F2F0',
        dark: '#2a2b38',
        globalBackgroundLight: '#f8f9fd',
        globalBackgroundDark: '#dcdddd',
        grayBackground: '#f0f4fb',
        grayShadeMedium: '#AAAAAF',
        grayShadeLight: '#B6B6B6',
        grayIcon: '#979797',
        grayShadeDark: '#288271',
        error: '#EA0849',
        errorDark: '#bb063a',
        errorLight: '#FEECF1',
        warningLight: '#fff4e2',
        warning: '#FFAB07',
        warningDark: '#ea900e',
        backdrop: 'rgba(0,0,0,0.4)',
        /**
         * Use this color for transparent white gradients.
         * `transparent` is interpreted differently by Safari, which causes design bugs (at least Safari 14.0 and earlier).
         * See also:
         * - https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#transparent_keyword
         * - https://www.w3.org/TR/css-color-4/#valdef-color-transparent
         */
        transparentWhite: 'rgba(255,255,255,0)',
    },
    textColors: {
        primary: '#2a2b38',
        primaryLight: (0, styleUtilities_1.withOpacity)('#2a2b38', 0.7),
        primaryLighter: (0, styleUtilities_1.withOpacity)('#2a2b38', 0.5),
        highlight: '#1b67d0',
        error: '#ea0849',
    },
    chartColors: {
        tan: '#e5a873',
        green: '#73e5a8',
        salmon: '#e57373',
        blue: '#95b8d3',
        turquoise: '#95d3cc',
    },
};
exports.default = colors;
